import React from 'react'
import './Widgets.css';
import InfoIcon from '@material-ui/icons/Info';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';

function Widgets() {

    const newsArticle = (heading, subtitle) => (
        <div className="widgets__article">
            <div className="widgets__articleLeft">
                <FiberManualRecordIcon/>
            </div>
            <div className="widgets__articleRight">
                <h4>{heading}</h4>
                <p>{ subtitle}</p>
            </div>
        </div>
    )

    return (
        <div className="widgets">
            

            {newsArticle("You may have lost someone you loved, but they will always live on in the memories you hold dear.", "-Unknown")}
            {newsArticle("It's okay to not be okay, but remember that it's also okay to heal, to move forward, and to find happiness again.", "-Unknown")}
            {newsArticle("Loss is not the end, it's a new beginning. Allow yourself time to grieve, but don't let it consume you. Rise above it and keep moving forward." ,"-Unknown")}

        </div>
    );
}

export default Widgets;
